import { ref } from 'vue';
import DeliveryPriceRepository from '@/repositories/delivery-price/DeliveryPriceRepository.ts';
import {
    DeliveryPrice,
    DeliveryPricesPaginator,
    DeliveryPricesRequestFilter,
    DeliveryPriceUpdateForm,
} from '@/types/delivery-price.type.ts';
import { PaginationMeta } from '@/types/pagination-meta.ts';
import useLoading from '@/utils/useLoading.ts';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useDeliveryPriceRepository() {
    const arDeliveryPrices = ref<DeliveryPrice[]>([]);
    const deliveryPricePaginationMeta = ref<PaginationMeta | null>(null);
    const { isLoading: isDeliveryPricesLoading, setLoading: setDeliveryPricesLoading } = useLoading();
    const deliveryPriceRepository = new DeliveryPriceRepository();

    const getDeliveryPrices = (requestFilter: DeliveryPricesRequestFilter): void => {
        setDeliveryPricesLoading(true);

        deliveryPriceRepository.getDeliveryPrices(requestFilter)
            .then((deliveryPricesPaginator: DeliveryPricesPaginator) => {
                arDeliveryPrices.value = deliveryPricesPaginator.data;
                deliveryPricePaginationMeta.value = deliveryPricesPaginator.meta;
                setDeliveryPricesLoading(false);
            });
    };

    const deactivateDeliveryPrice = (id: number): Promise<void> => {
        return deliveryPriceRepository.deactivateDeliveryPrice(id);
    };

    const getDeliveryPrice = (id: number): Promise<DeliveryPrice> => {
        return deliveryPriceRepository.getDeliveryPrice(id);
    };

    const updateDeliveryPrice = (id: number, form: DeliveryPriceUpdateForm): Promise<void> => {
        return deliveryPriceRepository.updateDeliveryPrice(id, form);
    };

    return {
        arDeliveryPrices,
        deliveryPricePaginationMeta,
        isDeliveryPricesLoading,
        getDeliveryPrices: getDeliveryPrices,
        deactivateDeliveryPrice: deactivateDeliveryPrice,
        getDeliveryPrice: getDeliveryPrice,
        updateDeliveryPrice: updateDeliveryPrice,
    };
}
